import { render, staticRenderFns } from "./DashCards.vue?vue&type=template&id=3fa5bc4f&scoped=true&"
import script from "./DashCards.vue?vue&type=script&lang=js&"
export * from "./DashCards.vue?vue&type=script&lang=js&"
import style0 from "./DashCards.vue?vue&type=style&index=0&id=3fa5bc4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa5bc4f",
  null
  
)

export default component.exports